<div class="ai-header">
  <h3 class="text-golden">Resumen de Informe generado con IA</h3>
  <div class="d-flex align-items-center ms-2 clickable help-tooltip" style="height: 2rem;">
    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#f2c63d">
      <path
        d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
    <div class="help title text-aqua">
      <span>Resumen generado con Inteligencia Artificial del informe original. El propósito de este resumen es
        transmitir de una forma clara, concisa y sencilla para el paciente los conceptos que el radiólogo ha querido
        transmitir durante el diagnóstico. Para ver el informe original, pulse en "Ver informe original" en la parte
        inferior del documento</span>
    </div>
  </div>
</div>
<hr>

<!-- <div class="" style="position: absolute; top: 90px; left: 250px;">
  <svg width="112" height="25" viewBox="0 0 112 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M63.6465 14.3397C61.0569 14.3397 58.9597 16.3607 58.9597 18.8554V23.353H68.313V14.3397H63.6465ZM44.8672 9.82502V0.8125H54.2198V5.31357C54.2198 7.80549 52.1241 9.82502 49.5388 9.82502H44.8672Z"
      fill="#C2DF0A" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M12.7962 17.7272C17.1812 17.7272 18.6531 14.1644 18.6531 11.9815C18.6531 9.26911 16.7118 6.27495 12.7587 6.27495C8.75531 6.27495 6.99005 9.51015 6.99005 12.0657C6.99005 14.1644 8.58772 17.7272 12.7962 17.7272ZM25.6385 23.2327H18.6531V20.7986H18.5684C17.3897 22.9865 14.4864 24 11.7465 24C4.33727 24 0 18.4136 0 11.9815C0 4.61289 5.51799 0 11.7465 0C15.5773 0 17.7273 1.78347 18.5684 3.16083H18.6531V0.770001H25.6385V23.2327Z"
      fill="#00B0CA" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M99.1589 17.7272C103.534 17.7272 105.009 14.1644 105.009 11.9815C105.009 9.26911 103.072 6.27495 99.1187 6.27495C95.1164 6.27495 93.3451 9.51015 93.3451 12.0657C93.3451 14.1644 94.9453 17.7272 99.1589 17.7272ZM112 23.2327H105.009V20.7986H104.922C103.748 22.9865 100.84 24 98.1055 24C90.6972 24 86.3613 18.4136 86.3613 11.9815C86.3613 4.61289 91.8715 0 98.1055 0C101.938 0 104.082 1.78347 104.922 3.16083H105.009V0.770001H112V23.2327Z"
      fill="#00B0CA" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M49.6489 14.3103H44.8706C44.4831 16.9368 42.7288 17.7347 40.9472 17.7347C37.1897 17.7347 37.1897 14.7774 37.1897 13.2376V0.8125H30.1924V14.2518C30.1924 17.325 30.436 18.9454 32.2964 21.1713C34.3633 23.6774 37.7363 24.0017 39.1684 24.0017C40.8326 24.0017 43.4427 23.7883 44.952 21.4141V23.2994H54.3129V18.6591C54.3129 16.2478 52.1808 14.3103 49.6489 14.3103Z"
      fill="#00B0CA" />
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M63.7034 9.85692H68.4772C68.8629 7.23067 70.619 6.43712 72.4034 6.43712C76.1601 6.43712 76.1601 9.39466 76.1601 10.9286V23.3533H83.1566V9.91836C83.1566 6.84376 82.9115 5.2206 81.053 2.99468C78.9827 0.487756 75.6101 0.164062 74.1754 0.164062C72.5181 0.164062 69.9046 0.378134 68.3943 2.75587V0.865776H59.0361V5.50921C59.0361 7.92009 61.1693 9.86048 63.7034 9.85692Z"
      fill="#00B0CA" />
  </svg>
</div> -->

<div class="ai-content text-golden">
  <p>
    <b>Nombre: </b><span>Nerea Blanco López</span>
  </p>
  <p>
    <b>Fecha Examen: </b><span>21/05/2021</span>
  </p>
  <p>
    <b>Descripción: </b><span>Resonancia de columna completa</span>
  </p>
  <p>
    <b>Médico: </b><span>Guillermo Ruiz Ortega</span>
  </p>

  <div class="ai-report text-aqua" [ngStyle]="{'margin-top': (expandedTools) ? '1.75rem' : '25%'}">
    <ul>
      <li>
        El informe muestra que la curvatura natural de la columna (lordosis) está conservada. Sin embargo, se observa
        una disminución en la señal de dos discos intervertebrales de la parte baja de la columna (L4-L5 y L5-S1), lo
        que indica posible desgaste. También hay cambios en los huesos que rodean el disco L5-S1, lo que sugiere un
        proceso de degeneración.
      </li>
      <li>
        Se identificó una leve protrusión (abultamiento) de los discos en los niveles de la parte baha de la columna
        L4-L5 y L5-S1, que está tocando la parte anterior de una estructura que envuelve la médula espinal (saco dural)
        y está reduciendo parcialmente el espacio por donde pasan los nervios. El resto de los tejidos y articulaciones
        alrededor de la columna se encuentran en condiciones normales.
      </li>
      <li>
        Conclusión: Hay un leve abultamiento de los discos en los niveles L4-L5 y L5-S1, lo cual puede estar afectando
        los nervios en esa área.
      </li>
    </ul>
  </div>

  <div class="ai-tools" [ngClass]="{expanded: expandedTools}">
    <div class="clickable" *ngIf="!expandedTools" (click)="expandTools();">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00ffff"
        style="transform: rotate(90deg); position: absolute;">
        <path d="M200-200v-240h80v160h160v80H200Zm480-320v-160H520v-80h240v240h-80Z" />
      </svg> -->
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00ffff"
        style="transform: rotate(90deg); position: absolute; right: 5px;">
        <path d="M200-200v-240h80v160h160v80H200Zm480-320v-160H520v-80h240v240h-80Z" />
      </svg>
      <div class="d-flex justify-content-center align-items-center h-100 w-100" style="padding-right: 20px;">
        <h3 class="text-aqua" style="margin: 0;">Herramientas IA</h3>
        <div class="d-flex align-items-center ms-2 clickable help-tooltip" style="height: 1.5rem;">
          <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#00ffff">
            <path
              d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
          </svg>
          <div class="help ia-tools text-aqua">
            <span>Herramientas de ayuda a la prescripción generadas con Inteligencia Artificial. Existen herramientas
              desde resumir el historial clínico del paciente hasta propuestas de prescripción y recetas</span>
          </div>
        </div>
      </div>
    </div>
    <div class="" *ngIf="expandedTools">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00ffff"
        (click)="expandedTools=!expandedTools" style="transform: rotate(90deg);" class="clickable">
        <path d="M440-440v240h-80v-160H200v-80h240Zm160-320v160h160v80H520v-240h80Z" />
      </svg> -->

      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#f2c63d"
        style="position: absolute; left: 5px;" (click)="showMenu=!showMenu" class="clickable">
        <path
          d="M280-600v-80h560v80H280Zm0 160v-80h560v80H280Zm0 160v-80h560v80H280ZM160-600q-17 0-28.5-11.5T120-640q0-17 11.5-28.5T160-680q17 0 28.5 11.5T200-640q0 17-11.5 28.5T160-600Zm0 160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520q17 0 28.5 11.5T200-480q0 17-11.5 28.5T160-440Zm0 160q-17 0-28.5-11.5T120-320q0-17 11.5-28.5T160-360q17 0 28.5 11.5T200-320q0 17-11.5 28.5T160-280Z" />
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00ffff"
        (click)="collapseTools();" style="transform: rotate(90deg); position: absolute; right: 5px;" class="clickable">
        <path d="M440-440v240h-80v-160H200v-80h240Zm160-320v160h160v80H520v-240h80Z" />
      </svg>

      <div class="d-flex justify-content-center align-items-center w-100 mt-2">
        <h3 class="text-aqua" style="margin-bottom: 0;">{{title}}</h3>
      </div>

      <hr>

      <div class="ai-tools-list" [ngClass]="{expanded: showMenu}">
        <div class="d-flex justify-content-start align-items-center">
          <h5 class="text-golden" style="margin: 0; display: inline-block;">Índice</h5>
          <!--<div class="d-flex align-items-center ms-2 clickable help-tooltip" style="height: 2rem;">
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#f2c63d">
              <path
                d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
            </svg>
            <div class="help index text-aqua">
              <span>Resumen generado con Inteligencia Artificial del informe original. El propósito de este resumen es
                transmitir de una forma clara, concisa y sencilla para el paciente los conceptos que el radiólogo ha
                querido
                transmitir durante el diagnóstico. Para ver el informe original, pulse en "Ver informe original" en la
                parte
                inferior del documento</span>
            </div>
          </div>-->
        </div>
        <div class="ai-tools-item" (click)="startTextGenerator('patient-history');">
          <span class="text-golden">· Resumen del historial</span>
        </div>
        <div class="ai-tools-item" (click)="startTextGenerator('terminology');">
          <span class="text-golden">· Explicar términos</span>
        </div>
        <div class="ai-tools-item" (click)="startTextGenerator('causes');">
          <span class="text-golden">· Posibles causas</span>
        </div>
        <div class="ai-tools-item" (click)="startTextGenerator('treatment');">
          <span class="text-golden">· Posible tratamiento</span>
        </div>
        <div class="ai-tools-item" (click)="startTextGenerator('prevention');">
          <span class="text-golden">· Prevención</span>
        </div>
        <div class="ai-tools-item" (click)="startTextGenerator('complementary_tests');">
          <span class="text-golden">· Pruebas complementarias</span>
        </div>
        <!-- <div class="ai-tools-item" (click)="startTextGenerator('patient-history');">
          <span class="text-aqua">1. Resumen del historial</span>
        </div>
        <div class="ai-tools-item" (click)="startTextGenerator('terminology');">
          <span class="text-aqua">2. Explicar términos</span>
        </div>
        <div class="ai-tools-item">
          <span class="text-aqua">3. Posibles causas</span>
        </div>
        <div class="ai-tools-item">
          <span class="text-aqua">4. Posibles tratamientos</span>
        </div>
        <div class="ai-tools-item">
          <span class="text-aqua">5. Preguntas al paciente</span>
        </div>
        <div class="ai-tools-item">
          <span class="text-aqua">6. Pruebas complementarias</span>
        </div> -->
        <div class="vr"></div>
      </div>

      <div class="ai-tools-content p-relative" [ngClass]="{collapsed: showMenu}">
        <img class="debrain-img" [ngClass]="{'shown': showMenu && !generatedText}" src="assets/img/myBrain4.png">
        <!-- <img class="debrain-text-img" [ngClass]="{'shown': showMenu && !generatedText}"
          src="assets/img/debrain_gold.png"> -->
        <div class="ai-tools-text" id="dynamic-text" [innerHTML]="generatedText">
        </div>
      </div>
    </div>
  </div>


  <span class="clickable underline text-golden" style="position: absolute; bottom: 10px; left: 20%;"
    (click)="reportService.activatedAI = false">Ver informe original</span>
</div>